export const environment = {
  production: false,
  name: 'staging',
  hubApiUrl: 'https://hub-api.airgateway.work',
  keycloakUrl: 'https://auth.airgateway.work',
  bpUrl: 'https://web.bookingpad.work',
  registerAvailable: true,
};
